<template>
  <div class="layout-template-drawer"
       @click="toggleVisible">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDrawer :visible.sync="visible"
                    v-on="$listeners">
      <slot name="content"
            :visible="visible"
            :hide-popover="hidePopover"></slot>
    </DataGridDrawer>
  </div>
</template>

<script>
import DataGridDrawer from './grid/DataGridDrawer'
export default {
  name: 'TemplateDrawer',
  components: {
    DataGridDrawer
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss">
  .layout-template-drawer {
    display: inline-block;
  }
</style>
